export default "__VITE_ASSET__Cl9_wE$R__"